export default __webpack_public_path__ + "static/media/sad-robot-400.0e00866c.png";